import React from 'react';

const GoogleMap = () =>{
  return (
    <iframe title="googleMap" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2537.9536068356256!2d30.467579599999993!3d50.4978212!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40d4cd8ccc5a73ff%3A0x41afba7304b76a5d!2z0JHQsNC70YLRltC50YHRjNC60LjQuSDQv9GA0L7QstGD0LvQvtC6LCAzLCDQmtC40ZfQsiwgMDQwNzM!5e0!3m2!1suk!2sua!4v1678321170541!5m2!1suk!2sua" style={{border: 0}} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
  );
};

export default GoogleMap;